import { Form, DatePicker, Button, Flex, notification, SelectProps, AutoComplete } from "antd";
import React, { useEffect, useState } from "react";
import SearchApi from "../api-services/search-api.service";
import { useNavigate, useSearchParams } from "react-router-dom";
import Icon from "@mdi/react";
import { mdiMapMarkerOutline } from "@mdi/js";
import { endOfDay, subDays } from "date-fns";
import ListApi from "../api-services/list-api.service";
import { monthFormat } from "../utils/antd.props";
import dayjs from "dayjs";

const renderItem = ({id, name}) => ({
  key: id,
  value: name,
  label: name
});

function SearchBarWidget(
    props: {
      searchLayout,
      destinationLabel:string, 
      destinationPlaceholder:string, 
      dateLabel:string, 
      datePlaceholder:string
    }
  ) {
  const searchApi = new SearchApi;
  const listApi = new ListApi;
  const navigate= useNavigate();
  const [searchParams] =  useSearchParams();
  const [options, setOptions] = useState<SelectProps['options']>([]);
  const disabledDate= (current) => {
    // Can not select days before today
    const date = subDays(new Date(), 1) 
    return current && current < endOfDay(date)
  };
  
  const initialFormValues = {};
  for (const [key, value] of searchParams.entries()) {
    if(key == "date"){
      initialFormValues["date"] = dayjs(value)
    }else{
      initialFormValues[key] = value;
    }
  }

  useEffect(() => {
      Promise.all([
        listApi.getLocations(),
        listApi.getItineraries(),
      ]).then(([locations, itineraries]) => {
        var options:any = [];
        if(locations.length > 0){
          options.push({
            label: <strong> Destinations </strong>,
            options: locations.map((location:any) => renderItem(location))
          })
        }
        if(itineraries.length > 0){
          options.push({
            label: <strong> Itineraries </strong>,
            options: itineraries.map((itinerary:any) => renderItem(itinerary))
          })
        }
        setOptions(options);
      }).catch(error => {
        notification.error({ message: 'Something went wrong.'});
      });
  }, []);


  const save = (formValues) => {
    let searchObj = {};
    Object.keys(formValues).forEach(filter => {
      if(formValues[filter]) {
        searchObj[filter] = filter === "date" && formValues[filter]?.format
          ? formValues[filter].format("YYYY-MM-01")
          : formValues[filter];
      }
    })

    searchObj["type"] = "series";
    
    const searchParams = new URLSearchParams(searchObj).toString();
    navigate(`/web/listing?${searchParams}`);
    navigate(0);
  }
  
  
  return (
    <div id="search-bar">
        <img src="/iceholidays-assets/images/Rectangle49.png"/>
        <div id="search-bar-widget">
          <Form
            initialValues={initialFormValues}
            onFinish={save}
            layout={props.searchLayout}
          >
            <Form.Item wrapperCol={{ span: 24 }} label={props.destinationLabel} name="keyword">
              <AutoComplete
                allowClear
                showSearch
                filterOption
                placeholder={props.destinationPlaceholder}
                suffixIcon={<Icon path={mdiMapMarkerOutline} size="16px" />}
                options={options}
              />
            </Form.Item>
            <Form.Item wrapperCol={{ span: 24 }} label={props.dateLabel} name="date">
              <DatePicker picker="month" format={monthFormat} inputReadOnly placeholder={props.datePlaceholder} disabledDate={disabledDate}/>
            </Form.Item>
            <Flex align="flex-end" justify="center">
              <Button type="primary" className="search-button" htmlType="submit">Search</Button>
            </Flex>
          </Form>
        </div>
        <img src="/iceholidays-assets/images/Rectangle49.png" className="flip"/>
      </div>
  )
}

SearchBarWidget.defaultProps = {
  searchLayout: "vertical",
  destinationLabel: "Search",
  destinationPlaceholder: "Destinations, Attractions, etc",
  dateLabel: "Travel Period",
  datePlaceholder: ""
}


export default SearchBarWidget;
